import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_safeInsets2hm6tkuvmrp7k as get_safeInsets } from '../ViewContextExtensions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../models/data.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../models/Rect.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function applySafeInsets(_this__u8e3s4, left, top, right, bottom) {
  left = left === VOID ? true : left;
  top = top === VOID ? true : top;
  right = right === VOID ? true : right;
  bottom = bottom === VOID ? true : bottom;
  var s = get_safeInsets(_this__u8e3s4.get_context_h02k06_k$());
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    var full = $this$reactive.invoke_r7m7el_k$(s);
    var tmp0_left = left ? full.left_1 : get_px(0);
    var tmp1_right = right ? full.right_1 : get_px(0);
    var tmp2_top = top ? full.top_1 : get_px(0);
    var tmp3_bottom = bottom ? full.bottom_1 : get_px(0);
    _this__u8e3s4.set_safeAreaPadding_bpzgd4_k$(Edges().new_com_lightningkite_kiteui_models_Edges_xdg8au_k$(tmp0_left, tmp2_top, tmp1_right, tmp3_bottom));
    return Unit_instance;
  });
}
//region block: exports
export {
  applySafeInsets as applySafeInsets1yyre4vmrimte,
};
//endregion

//# sourceMappingURL=safeInsetsHelpers.mjs.map
